let HELPTEXT = {
  order_type: {
    title: `Privat oder Geschäftlich`,
    text: "Bitte wählen Sie aus, ob Sie den Antrag als Privatperson oder als Unternehmen stellen. Wenn Sie als Unternehmer mit einer Umsatzsteuer-ID bestellen, wählen Sie 'Geschäftlich'. Bestellen Sie als Unternehmer ohne Umsatzsteuer-ID, wählen Sie entweder 'Privat' oder 'Gewerblich ohne USt-Id'."
  },

  property_address: {
    title: `Adresse`,
    text: `Geben Sie hier bitte die Adresse des Gebäudes ein, für welches der Energieausweis erstellt werden soll. <br><br>Die Rechnungs- und Lieferadresse können Sie im nächsten Schritt angeben.`
  },

  /**
   * STEP 1
   */
  // gemischt genutzte Gebäude siehe GEG $79 Abs. 2
  property_building_type: {
    title: `Gebäudeart`,
    text: `Bei einem gemischt genutzten Gebäude empfehlen wir einen Bedarfsausweis, da dieser genauere Ergebnisse liefert.`
  },

  property_space_an: {
    title: `Gebäudenutzfläche`,
    text: `Die Gebäudenutzfläche ist die Fläche eines Gebäudes, die tatsächlich genutzt wird, und umfasst alle beheizten Räume mit einer lichten Raumhöhe von mindestens 2,00 m.`
  },
  vat_id: {
    title: `Umsatzsteuer-Id Prüfung`,
    text: `Nachdem Sie Ihre Umsatzsteuer-Identifikationsnummer eingegeben haben, führen wir eine Überprüfung auf Gültigkeit durch. Sollte sich herausstellen, dass die Umsatzsteuer-ID ungültig ist, so haben Sie die Möglichkeit, Ihre Bestellung entweder als Privatperson oder als Unternehmen ohne Angabe einer USt-ID fortzuführen. <br><br>Um die Gültigkeit Ihrer Umsatzsteuer-ID eigenständig zu verifizieren, besuchen Sie bitte die Webseite der <a href="https://ec.europa.eu/taxation_customs/vies/#/vat-validation" target="_blank">Europäischen Kommission</a>. <br><br>Falls die Überprüfung fehlschlägt, obwohl die eingegebenen Daten korrekt sind, versuchen Sie bitte, die Prüfung durch Klicken auf "Neu Prüfen" erneut auszulösen, oder wenden Sie sich an unseren Kundenservice für weitere Unterstützung.`
  },
  ba_heater_regulator: {
    title: `Heizungsregler`,
    text: `Wählen Sie die Art des Heizungsreglers in Ihrem System. Die Optionen reichen von einfachen ungeregelten Systemen bis hin zu hochentwickelten Reglern mit Optimierungsfunktionen.`
  },

  ba_heater_storage_type: {
    title: `Speichersystem der Heizung `,
    text: `Ein Pufferspeicher ist ein großer, isolierter Wasserbehälter, der überschüssige Wärme aus der Heizung speichert und bei Bedarf abgibt. Das verbessert die Effizienz der Anlage.
<br><br>
<b>Woran erkenne ich einen Pufferspeicher?</b><br>
Typisch ist ein großer, zylindrischer Tank (meist im Heizungsraum) mit mehreren Rohranschlüssen.
<ul>
<li>
Pufferspeicher vorhanden: Wählen Sie diese Option, wenn Ihre Heizungsanlage einen solchen Speicher hat.
</li>
<li>
Pufferspeicher nicht vorhanden: Wählen Sie diese Option, wenn Ihre Heizungsanlage keinen solchen Speicher besitzt.
</li>
</ul>
<br><b>Hinweis:</b> Die Angabe ist wichtig, da ein Pufferspeicher den Energieverbrauch beeinflusst und dadurch die Einstufung im Energieausweis verbessert werden kann. Bei Unsicherheiten können Sie uns gerne eine Kundennotiz hinterlassen oder ein Foto des Heizungsraums hochladen.`
  },

  ba_heater2_storage_type: {
    title: `Speichersystem der 2. Heizung `,
    text: `Ein Pufferspeicher ist ein großer, isolierter Wasserbehälter, der überschüssige Wärme aus der Heizung speichert und bei Bedarf abgibt. Das verbessert die Effizienz der Anlage.
<br><br>
<b>Woran erkenne ich einen Pufferspeicher?</b><br>
Typisch ist ein großer, zylindrischer Tank (meist im Heizungsraum) mit mehreren Rohranschlüssen.
<ul>
<li>
Pufferspeicher vorhanden: Wählen Sie diese Option, wenn Ihre Heizungsanlage einen solchen Speicher hat.
</li>
<li>
Pufferspeicher nicht vorhanden: Wählen Sie diese Option, wenn Ihre Heizungsanlage keinen solchen Speicher besitzt.
</li>
</ul>
<br><b>Hinweis:</b> Die Angabe ist wichtig, da ein Pufferspeicher den Energieverbrauch beeinflusst und dadurch die Einstufung im Energieausweis verbessert werden kann. Bei Unsicherheiten können Sie uns gerne eine Kundennotiz hinterlassen oder ein Foto des Heizungsraums hochladen.`
  },

  ba_heater_tube_system: {
    title: `Heizungssystem`,
    text: `Wählen Sie das Rohrsystem Ihrer Heizung. Ein 1-Rohr-System führt das Heizwasser durch alle Heizkörper in Serie, während ein 2-Rohr-System das Heizwasser parallel verteilt.
    <br>
    <br>
<div>
<b>Woran erkennen Sie Ihr System?</b>
<ul>
<li>
Bei einem 1-Rohr-System sind die Heizkörper wie an einer einzelnen durchgehenden Rohrleitung angeschlossen.
</li>
<li>
Bei einem 2-Rohr-System hat jeder Heizkörper einen eigenen Vorlauf- und Rücklaufanschluss.
</li>
</ul>
</div>`
  },

  ba_heater_heating_hydraulic_balancing: {
    title: `Hydraulischer Abgleich der Heizung`,
    text: `<p class="content">
  Bitte wählen Sie aus, ob Ihre Heizungsanlage bereits einen hydraulischen Abgleich hat.<br>
  Ein hydraulischer Abgleich stellt sicher, dass alle Heizkörper im Haus gleichmäßig mit Heizwasser versorgt werden. Dadurch werden Räume effizienter und gleichmäßiger beheizt – das spart Energie und Kosten.
</p>
<div>

<strong>Woran erkennen Sie, ob Ihre Heizung hydraulisch abgeglichen ist?</strong>
<ul>
  <li>Sie haben einen Nachweis oder eine Bestätigung Ihres Heizungsinstallateurs (z.&nbsp;B. ein Protokoll, eine Rechnung oder einen Vermerk im Wartungsheft).</li>
  <li>Der hydraulische Abgleich wurde im Rahmen einer Modernisierung oder beim Einbau einer neuen Heizung durchgeführt (häufig ab Baujahr 2005 oder neuer).</li>
  <li>In der Heizungsrechnung oder im Angebot steht explizit „hydraulischer Abgleich“ als ausgeführte Leistung.</li>
</ul>
</div>
`
  },
  ba_wall_length_a: {
    title: ``, text: ``
  },


  ba_water2_splitting_pipe_type: {
    title: `Verteilung der WW-Anlage (2.ET)`,
    text: ` <p>Wählen Sie aus, wie die Warmwasserverteilung in der zweiten Einheit (2.ET) erfolgt.</p>
  <ul>
    <li><strong>Zentrale Verteilung mit Zirkulation:</strong> Das Warmwasser wird zentral erzeugt und über ein Leitungssystem mit einer Umwälzpumpe (Zirkulation) ständig im Kreislauf gehalten, sodass an den Zapfstellen sofort warmes Wasser verfügbar ist.</li>
    <li><strong>Zentrale Verteilung ohne Zirkulation:</strong> Das Warmwasser wird zentral erzeugt und über ein Leitungssystem verteilt, aber es gibt keine Umwälzpumpe. Es dauert daher meist etwas, bis warmes Wasser an den Zapfstellen ankommt.</li>
    <li><strong>Dezentrales System:</strong> Das Warmwasser wird direkt an oder nahe der Zapfstelle erzeugt, zum Beispiel durch Boiler oder Durchlauferhitzer in Küche oder Bad.</li>
    <li><strong>Wohnungsweise Verteilung:</strong> Jede Wohnung hat eine eigene Warmwasserbereitung und eigene Leitungen, unabhängig von anderen Einheiten im Gebäude.</li>
  </ul>`
  },

  notice_customer: {
    title: `Individuelle Anmerkungen`,
    text: `Sie können uns hier individuelle Anmerkungen zu Ihrem Auftrag hinterlassen.`
  },

  ba_roof_form: {
    title: `Dachform`,
    text: `Bitte teilen Sie uns die Dachform Ihres Gebäudes mit. Sollte Ihr Gebäude über eine abweichende Dachform verfügen, wählen Sie bitte "Satteldach" und legen Informationen zur Dachform in den Anmerkungen nieder.`
  },

  jamb_existing: {
    title: `Kniestock`, text: `
<img alt="Kniestock" class="m-r-xs" src="/images/form/Kniestock.png" style="width: auto;height:160px;" align=left>
Ein Kniestock ist ein Wandabschnitt, der zwischen dem obersten Geschoss und dem Dach eines Hauses liegt
<br>
Der Kniestock befindet sich in der Regel unterhalb des obersten Geschosses und erstreckt sich bis zur Dachkonstruktion. Die Außenwand, die die Luft berührt, ist hier relevant. Die innere Abmauerung oder Ähnliches ist nicht maßgebend.
`
  },

  ba_roof_tilt: {
    title: `Dachneigung`,
    text: `Bitte geben Sie die Neigung Ihres Daches in Grad an. Die Dachneigung beschreibt den Winkel, den die Dachfläche zur Horizontalen bildet.`
  },

  ba_attic_height: {
    title: `Dachgeschosshöhe`,
    text: `Geben Sie hier die Höhe des Dachgeschosses an. Die Dachgeschosshöhe ist der Abstand zwischen der Oberkante des Fußbodens und der Unterkante der Dachkonstruktion. <br><br>Sollten Sie sich unsicher sein, drücken Sie bitte "Dachgeschosshöhe ermitteln". Wir werden anschließend anhand Ihrer Gebäudeangaben die Dachgeschosshöhe für Sie berechnen. <br><br>Bitte geben Sie die Höhe des Dachgeschosses an. Sollte ein Dach- bzw. Spitzboden vorhanden sein, geben Sie bitte nur die Höhe der unteren Ebene an und erfassen den Spitzboden als 2. Dachgeschoss.`
  },

  product: {
    title: `Energieausweistyp`,
    text: `Wählen Sie hier den Typ des Energieausweises aus. Der Verbrauchausweis zeigt den tatsächlichen Energieverbrauch einer Immobilie an, während der Bedarfsausweis den voraussichtlichen Energiebedarf darstellt der für die Beheizung der Immobilie notwendig ist. Welcher Ausweis für eine Immobilie geeignet ist, hängt von verschiedenen Faktoren wie Baualter, Gebäudetyp und Renovierungszustand ab. <br>Sollen Sie sich unsicher sein, welcher Ausweis für Ihre Immobilie geeignet ist, können Sie sich gerne an uns wenden oder unseren <a href='/public'>Kurz-Fragebogen</a> auf der Startseite verwenden.`
  },
  ba_roof_height: {
    title: `Dachgeschosshöhe`,
    text: `Geben Sie hier die Höhe des Dachgeschosses an. Die Dachgeschosshöhe ist der Abstand zwischen der Oberkante des Fußbodens und der Unterkante der Dachkonstruktion.`
  },

  ShareFormInputLinkJob: {
    title: `Link zum Auftrag`,
    text: `Wir senden Ihnen einen Link zu Ihrem Auftrag per E-Mail zu. Mit diesem Link können Sie jederzeit auf Ihren Auftrag zugreifen und den Status Ihrer Bestellung einsehen.`
  },

  roller_shutter_boxes: {
    title: `Rollladenkästen`,
    text: `Bitte geben Sie an, ob Ihre Immobilie über Rollladenkästen verfügt. Rollladenkästen sind Gehäuse, in denen die Rollläden aufgerollt und verstaut werden. Sie können sich entweder innen oder außen an den Fenstern befinden.`
  },

  property_building_year: {
    title: `Baujahr des Gebäudes`, text: `Bitte geben Sie das ursprüngliche Baujahr des Gebäudes an. Maßgeblich ist dabei das Datum des Bauantrags.
<br>
Falls das genaue Baujahr nicht bekannt ist, können Sie alternativ das Jahr der Fertigstellung angeben.
<br>
Baujahre von späteren Umbauten oder Sanierungen können Sie im weiteren Verlauf der Bestellung ergänzen.`
  },

  ba_property_building_energyefficiency: {
    title: `Effizienz- oder Passivhaus`,
    text: `Handelt es sich um ein Objekt nach Effizienz- oder Passivhaus-Standard?`
  },

  property_units: {
    title: `Anzahl Wohnungen`,
    text: `Da Energieausweise nur für das gesamte Gebäude und nicht für einzelne Wohnungen ausgestellt werden dürfen, sind Informationen zu allen Wohnungen im Gebäude erforderlich. Einliegerwohnungen zählen Sie bitte als separate Wohneinheiten. Bei Einfamilienhäusern, falls es keine weiteren Wohnungen im Gebäude gibt, wählen Sie bitte 1 Wohneinheit aus.`
  },

  property_space_va: {
    title: `Wohnfläche`,
    text: `Der Energieausweis ist immer an das jeweilige Gebäude gebunden. Daher bitten wir Sie, die Wohnfläche des gesamten Gebäudes (außer Keller) in Quadratmetern anzugeben. Basierend auf dieser Angabe wird die Gebäudenutzfläche automatisch im Energieausweis berechnet.`
  },

  property_space_ba: {
    title: `Wohnfläche`,
    text: `Bitte tragen Sie hier die Größe der beheizten Wohnfläche in Quadratmetern ein. Dies bezieht sich auf die DIN-Wohnfläche, ohne die Flächen, die sich außerhalb des Gebäudes befinden (z. B. Balkone, Terrassen).`
  },

  property_space_net: {
    title: `Nettogrundfläche`, text: `Nettogrundfläche (NGF) gem. EnEV / DIN 277.`
  },

  heater_building_year: {
    title: `Baujahr der Heizung`,
    text: `Das Baujahr der Heizungsanlage finden Sie im Abgasmessprotokoll, in der Betriebsanleitung, auf dem Typenschild, im Abnahmeprotokoll, etc. Bei Nutzung von Fernwärme geben Sie bitte das Baujahr der Fernwärmeübergabestation an. Falls Ihr Kessel modernisiert wurde, geben Sie bitte das Jahr der Modernisierung an. Nicht relevant ist das Modernisierungsjahr des Brenners. Bei mehreren Geräten bitte das vorherrschende Baujahr angeben. `
  },

  heater2_building_year: {
    title: `Baujahr der Heizung (Sekundär)`,
    text: `Bitte geben Sie hier nur das Baujahr der zweiten Heizung an.`
  },

  ventilation: {
    title: `Art der Lüftung`,
    text: `Auf welche Weise erfolgt die Lüftung des Gebäudes? Beispiele für Lüftungsanlagen ohne Wärmerückgewinnung sind Abluftanlagen in Räumen ohne Fenster, wie beispielsweise Badezimmern. Lüftungsanlagen mit Wärmerückgewinnung umfassen beispielsweise zentrale oder dezentrale Zu- und Abluftsysteme, die mit Wärmetauschern ausgestattet sind.`
  },

  renewable_energy: {
    title: `Erneuerbare Energien`,
    text: `Werden erneuerbare Energien verwendet? <br> Sie können hier eine Mehrfachauswahl wie beispielsweise Photovoltaik & Wärmepumpe auswählen. Bitte berücksichtigen Sie, dass Photovoltaikanlagen ausschließlich elektrischen Strom erzeugen. Diese Stromerzeugung wird jedoch nicht in den Verbrauchsausweis einbezogen. Mit Solarthermieanlagen wird durch Sonnenenergie die Warmwasserbereitung unterstützt, die sich auf Ihre Verbrauchswerte auswirken.`
  },

  ba_floor_plan_shape: {
    title: `Gebäude Grundrissform`,
    text: `Geben Sie hier die Form ihrer Immobilie an.<br><br> Weicht die Grundrissform von den hier dargestellten ab, wählen Sie bitte die Form, die Ihrer am nächsten liegt und addieren Sie gegebenfalls die Längen. Sie können im letzten Schritt Grundrisse und/oder Skizzen hochladen.`
  },


  /**
   * Step 2
   */

  energy_source: {
    title: `Energieträger`, text: `Bitte wählen Sie hier Ihren Hauptenergieträger aus.`
  },

  energy_source2: {
    title: `Sekundärer Energieträger`,
    text: `Hier können Sie einen zweiten Energieträger angeben. Dies könnte zum Beispiel ein Kachelofen sein.`
  },

  energy_source_usage2: {
    title: `Sekundärer Energieträger`,
    text: `Sofern Sie einen zweiten Energieträger verwenden, können Sie nun Angaben zu diesem Energieträger angeben. Dies könnte zum Beispiel ein Kachelofen sein.`
  },

  address: {
    title: `Adresse`,
    text: `Bitte geben Sie die Adresse an, die auf der Rechnung erscheinen soll. Falls Sie den optionalen Postversand wählen, senden wir Ihren Energieausweis ebenfalls an diese Adresse.
<br><br>
Wenn Sie unterschiedliche Adressen für den Versand und die Rechnung benötigen, tragen Sie bitte die zusätzliche Adresse im Anmerkungsfeld ein oder kontaktieren Sie direkt unseren Kundendienst.
<br><br>
Sollte sich Ihre Adresse im Ausland befinden, können Sie auch eine ausländische Adresse angeben. Wir versenden auch ins Ausland.`
  },
  energy_source_unit: {
    title: `Einheit`,
    text: `Bitte geben Sie die korrekte Verbrauchseinheit des Energieträgers/Brennstoffes an. <br>Diese finden Sie in der Regel auf Ihrer Heizkostenabrechnung.`
  },

  energy_source2_unit: {
    title: `Einheit (sekundärer Energieträger)`,
    text: `Bitte geben Sie die Verbrauchseinheit des sekundären Energieträgers/Brennstoffes an. <br>Diese finden Sie in der Regel auf Ihrer Heizkostenabrechnung.`
  },

  energy_source_water_heating: {
    title: `Energieträger (Warmwasser)`,
    text: `Bitte wählen Sie hier Ihren Energieträger aus, der für die Warmwasserbereitung verwendet wird.`
  },

  billing_period1_usage: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  billing_period2_usage: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  billing_period3_usage: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  billing_period1_usage2: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  billing_period2_usage2: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  billing_period3_usage2: {
    title: `Verbrauchseingabe`,
    text: `Bitte geben Sie hier den Gesamtverbrauch des Energieträgers für jede Periode ein. Eine Abrechnungsperiode ist stets ein Jahr lang. <br>Bei Mehrfamilienhäusern sollten Sie den Gesamtenergieverbrauch des gesamten Gebäudes angeben, da Energieausweise immer auf das gesamte Haus bezogen sind.<br>Falls es sich um ein Blockheizkraftwerk (BHKW) handelt, geben Sie bitte nur die Menge der produzierten Wärme (ohne Strom) an.`
  },

  ba_f_p: {
    title: `Primärenergiefaktor`, text: `Bitte geben Sie den entsprechenden Wert für Ihren Nah- oder Fernwärmeversorger ein. Der Primärenergiefaktor ist ein Maß für die Umweltauswirkungen der Energieversorgung und sollte von Ihrem Versorger bereitgestellt werden. Falls Sie diesen Wert nicht kennen, nennen Sie uns bitte den Namen Ihres Versorgers.
<br><br>Achten Sie darauf, den Wert korrekt und in der richtigen Einheit (z. B. 0,8 oder 1,2) einzugeben.`
  },

  air_conditioning: {
    title: `Anlage zum Kühlen`,
    text: `Bitte geben Sie an, ob Ihre Immobilie im Sommer gekühlt wird. Dies kann beispielsweise über eine Klimaanlage geschehen.`
  },

  ba_solar_collector_keymark_certified: {
    title: `Solar-System`, text: `<img alt="Solar Keymark" class="m-r-xs" src="/images/form/keymark_signet.png" style="width: auto;height:160px;" align=left>
Das Solar Keymark ist ein freiwilliges Zertifizierungszeichen, das die Konformität solarthermischer Produkte mit den europäischen Standards bestätigt.<br><br>
Bitte wählen Sie die Checkbox an, sofern Ihr Solar-System das Siegel besitzt.`
  },

  cooling_type: {
    title: `Art der Kühlen`,
    text: `Wählen Sie hier die Art der Kühlung aus. Sofern mehrere Kühlungsarten vorhanden sind, wählen Sie bitte alle Kühlungsarten aus.`
  },

  cooling_area: {
    title: `Gekühlte Fläche`,
    text: `Bitte geben Sie die Fläche des Gebäudes an, die aktiv klimatisiert oder gekühlt wird. Dazu zählen alle Räume, in denen eine Kühlanlage zur Senkung der Raumtemperatur genutzt wird.
<br>
Nicht berücksichtigt werden Flächen, die ausschließlich durch natürliche Belüftung oder Fenster geöffnet werden können, sowie nicht genutzte Nebenräume.`
  },

  ba_floor_heating: {
    title: `Fußbodenheizung`,
    text: `Wählen Sie aus, ob die Wärme über Heizkörper oder über eine Fußbodenheizung abgegeben wird. <br><br>Falls Sie sowohl Fußbodenheizung als auch Heizkörper haben, wählen Sie bitte aus, worüber die Wärme hauptsächlich abgegeben wird.`
  },

  radiator_niche: {
    title: `Heizungsnischen`,
    text: `Wählen Sie aus, ob die Heizkörper in Nischen eingebaut sind. Diese erkennen Sie daran, ob die Heizung von der Wand absteht oder in die Wand eingelassen ist.`
  },

  first_billing_period: {
    title: `Erste Abrechnungsperiode`,
    text: `Für die Beantragung eines Verbrauchsausweises müssen Verbrauchswerte der letzten drei Jahre vorliegen – das heißt, die erste Abrechnungsperiode muss mindestens drei Jahre zurückliegen. Geben Sie hier Monat und Jahr des Beginns der ersten Abrechnungsperiode an`
  },

  long_vacant: {
    title: `Gab es einen längeren Leerstand?`,
    text: `Ein längerer Leerstand liegt vor, wenn 5% Leerstand über den gesamten Abrechnungszeitraum (Warmwasser) bzw. 10% über die Wintermonate Oktober bis März (Heizung) überschritten wurden. Sollten nur einzelne Zimmer (z. B. frühere Kinderzimmer) leer gestanden haben, zählen Sie dies bitte nicht als Leerstand hinzu.`
  },

  ba_water_storage_type: {
    title: `Speichertyp Warmwasser`,
    text: `<p>Geben Sie hier an, welcher Typ von Warmwasserspeicher in Ihrem Gebäude verwendet wird.</p>
  <p><strong>Woran erkenne ich den Speichertyp?</strong></p>
  <ul>
    <li><strong>Indirekt beheizter Speicher:</strong> Der Speicher wird über die Heizungsanlage (meist durch einen Wärmetauscher) erhitzt, nicht direkt durch Gas oder Strom.</li>
    <li><strong>Gasbeheizter Speicher:</strong> Der Speicher hat eine eigene Gasbrenneinheit und wird direkt durch Gasflamme oder Gasbrenner erhitzt.</li>
    <li><strong>Elektrisch beheizter Speicher:</strong> Der Speicher enthält elektrische Heizelemente, die das Wasser direkt mit Strom erwärmen.</li>
  </ul>`
  },

  ba_water2_storage_type: {
    title: `Speichertyp 2. Warmwasser`,
    text: `<p>Geben Sie hier an, welcher Typ von Warmwasserspeicher in Ihrem Gebäude verwendet wird.</p>
  <p><strong>Woran erkenne ich den Speichertyp?</strong></p>
  <ul>
    <li><strong>Indirekt beheizter Speicher:</strong> Der Speicher wird über die Heizungsanlage (meist durch einen Wärmetauscher) erhitzt, nicht direkt durch Gas oder Strom.</li>
    <li><strong>Gasbeheizter Speicher:</strong> Der Speicher hat eine eigene Gasbrenneinheit und wird direkt durch Gasflamme oder Gasbrenner erhitzt.</li>
    <li><strong>Elektrisch beheizter Speicher:</strong> Der Speicher enthält elektrische Heizelemente, die das Wasser direkt mit Strom erwärmen.</li>
  </ul>`
  },

  ba_water_location: {
    title: `Standort der Wasserbereitung`,
    text: `<p>Geben Sie hier an, ob sich die Warmwasserbereitung innerhalb oder außerhalb der thermischen Hülle des Gebäudes befindet.</p>
  <p><strong>Woran erkenne ich den Standort?</strong></p>
  <ul>
    <li><strong>Innerhalb thermischer Hülle:</strong> Die Warmwasserbereitung befindet sich in beheizten oder gedämmten Bereichen, z. B. im Wohnbereich, im Technikraum innerhalb des Gebäudes oder im beheizten Keller.</li>
    <li><strong>Außerhalb thermischer Hülle:</strong> Die Warmwasserbereitung befindet sich in unbeheizten oder nicht gedämmten Bereichen, z. B. in einem separaten, kalten Anbau, im unbeheizten Keller oder außerhalb des Gebäudes.</li>
  </ul>`
  },

  ba_water2_location: {
    title: `Standort der 2. Wasserbereitung`,
    text: `<p>Geben Sie hier an, ob sich die Warmwasserbereitung innerhalb oder außerhalb der thermischen Hülle des Gebäudes befindet.</p>
  <p><strong>Woran erkenne ich den Standort?</strong></p>
  <ul>
    <li><strong>Innerhalb thermischer Hülle:</strong> Die Warmwasserbereitung befindet sich in beheizten oder gedämmten Bereichen, z. B. im Wohnbereich, im Technikraum innerhalb des Gebäudes oder im beheizten Keller.</li>
    <li><strong>Außerhalb thermischer Hülle:</strong> Die Warmwasserbereitung befindet sich in unbeheizten oder nicht gedämmten Bereichen, z. B. in einem separaten, kalten Anbau, im unbeheizten Keller oder außerhalb des Gebäudes.</li>
  </ul>`
  },

  ba_water_splitting_pipe_location: {
    title: `Standort der Wasserverteilung`,
    text: `<p>Geben Sie hier an, wo sich das Verteilungsnetz für das Warmwasser (WW-Verteilung) hauptsächlich befindet.</p>
  <p><strong>Woran erkenne ich den Standort?</strong></p>
  <ul>
    <li><strong>Verteilung innerhalb thermischer Hülle:</strong> Die Warmwasserleitungen verlaufen überwiegend in beheizten oder wärmegedämmten Bereichen, z. B. innerhalb der Wohnräume oder im gedämmten Keller.</li>
    <li><strong>Verteilung außerhalb thermischer Hülle:</strong> Die Warmwasserleitungen verlaufen größtenteils in unbeheizten oder ungedämmten Bereichen, etwa in einem unbeheizten Keller, Nebenräumen oder außerhalb des Gebäudes.</li>
  </ul>
  <p><strong>Hinweis:</strong> Die thermische Hülle bezeichnet den wärmegedämmten und beheizten Bereich eines Gebäudes.</p>
   `
  },

  ba_water2_splitting_pipe_location: {
    title: `Standort der 2. Wasserverteilung`,
    text: `<p>Geben Sie hier an, wo sich das Verteilungsnetz für das Warmwasser (WW-Verteilung) hauptsächlich befindet.</p>
  <p><strong>Woran erkenne ich den Standort?</strong></p>
  <ul>
    <li><strong>Verteilung innerhalb thermischer Hülle:</strong> Die Warmwasserleitungen verlaufen überwiegend in beheizten oder wärmegedämmten Bereichen, z. B. innerhalb der Wohnräume oder im gedämmten Keller.</li>
    <li><strong>Verteilung außerhalb thermischer Hülle:</strong> Die Warmwasserleitungen verlaufen größtenteils in unbeheizten oder ungedämmten Bereichen, etwa in einem unbeheizten Keller, Nebenräumen oder außerhalb des Gebäudes.</li>
  </ul>
  <p><strong>Hinweis:</strong> Die thermische Hülle bezeichnet den wärmegedämmten und beheizten Bereich eines Gebäudes.</p>
`
  },

  ba_water_building_year: {
    title: `Jahr des Warmwassersystems`,
    text: `<p>Geben Sie hier an, in welchem Jahr das derzeitige Warmwassersystem installiert oder zuletzt grundlegend erneuert wurde.</p>
  <p><strong>Woran erkenne ich das Jahr des Warmwassersystems?</strong></p>
  <ul>
    <li>Das Baujahr oder Erneuerungsjahr steht oft auf einem Typenschild am Gerät oder in den Unterlagen des Herstellers.</li>
    <li>Falls das genaue Jahr unbekannt ist, schreiben Sie gerne eine Bemerkung in das Notizfeld.</li>
  </ul>`
  },

  ba_heater_distribution_insulated: {
    title: `Dämmung Heizungsrohre`,
    text: `
 Geben Sie an, ob die frei sichtbaren Heizungsrohre in unbeheizten Bereichen (z. B. Keller) mit einer Dämmschicht versehen sind.<br><br>
    <b>Woran erkenne ich gedämmte Rohre?</b><br>
Gedämmte Rohre sind mit einer dicken, meist grauen oder schwarzen Isolierung ummantelt. Ungedämmte Rohre bestehen nur aus Metall und sind direkt sichtbar.
<ul>
<li>
Ja: Wählen Sie diese Option, wenn alle freiliegenden Heizungsrohre in unbeheizten Bereichen sichtbar isoliert sind.
</li>
<li>
Nein: Wählen Sie diese Option, wenn die Rohre nicht oder nur teilweise gedämmt sind.
</li>
</ul>
`
  },

  long_vacant_percentage: {
    title: `Leerstand in Prozent`, text: `Bitte geben Sie hier den Leerstand in % für ein gesamtes Jahr und für die gesamte Fläche an. <br><br>

<b>Berechnung des Leerstands</b> 

Sie addieren den Leerstand über die Monate und dividieren diesen durch 12. Anschließend multiplizieren Sie den Wert mit 100 und Sie erhalten den Prozent.

<br><br>
<b>Beispiel</b>
Wenn das Objekt in 12 Monate 3 Monate Leerstand besaß, so wären dies 25 %.<br>
Rechnung: 3 / 12 * 100 = 25 %`
  },


  ba_wall_mounted: {
    title: `Wand angebaut?`,
    text: `Grenzt eine Wand an ein anderes Gebäude, wählen Sie bitte aus, dass diese Wand angebaut ist. Sofern Sie sich unsicher sind, was Sie auswählen sollen, hinterlassen Sie bitte eine Kundennotiz.`
  },

  ba_property_orientation: {
    title: `Orientierung des Gebäudes`,
    text: `Wählen Sie bitte die Himmelsrichtung aus, in die die Wand A des Gebäudes zeigt. Sollten Sie sich unsicher sein, so schreiben Sie uns bitte nach der Bestellung eine Nachricht, sodass wir die Ausrichtung für Sie ermitteln können.`
  },

  ba_property_part: {
    title: `Gebäudeteil`,
    text: `Es handelt sich im hiesigen Sinne nur dann um ein Mischgebäude, wenn zwei getrennte Energieausweise ausgestellt werden müssen. Dies ist der Fall, wenn Gewerbe- und Wohnbereiche in einem engeren Verhältnis als 90 % und 10 % zueinander stehen. In allen anderen Fällen muss "Wohngebäude" ausgewählt werden. <br>Des Weiteren kann ein gemeinsamer Energieausweis erstellt werden, wenn sich die Heizungsanlage nicht wesentlich unterscheidet.<br>Energieausweise für Nichtwohngebäude stellen wir aktuell nicht aus.`,
    video_url: `https://www.youtube.com/watch?v=4n7BnFIz9Zo`
  },


  /**
   * Step 2
   */

  ba_full_floors: {
    title: `Anzahl Vollgeschosse (beheizt)`,
    text: `
<img alt="Vollgeschosse" class="m-r-xs" src="/images/form/Vollgeschosse.png" style="width: auto;height:160px;" align=left>
Kellergeschosse und Geschosse mit Schrägen sind <u>nicht mitzuzählen</u> und werden separat abgefragt.
`
  },

  ba_full_floor_height: {
    title: `Mittlere Vollgeschosshöhe`,
    text: `Als Vollgeschosshöhe bezeichnet man den vertikalen Abstand von der Oberkante eines Fußbodens bis zur Oberkante des darüberliegenden Fußbodens, einschließlich der dazwischenliegenden Decke.
<br>
<b>Die Geschosshöhe umfasst somit die lichte Raumhöhe sowie die Konstruktionsstärke der Decke darüber.</b>`
  },

  ba_attic: {
    title: `Dachgeschoss`,
    text: `Geben Sie bitte die Bauweise Ihres Dachgeschosses an (oberste Geschossdecke). Meist sind Holzbalkendecken vorhanden. Wenn dies bei Ihnen abweicht, geben Sie bitte "massive Decke" an.`
  },

  ba_attic_heated: {
    title: `Dachgeschoss beheizt?`,
    text: `Geben Sie bitte an, ob Ihr Dachgeschoss entweder direkt oder durch einen Luftverbund beheizt ist. Ist das Dachgeschoss nur teilweise beheizt, so geben Sie bitte beheizt an.<br>In diesem Kontext bezieht sich das Wort <b>"Dachgeschoss" auf das erste Stockwerk, das schräge Decken</b> hat.`
  },
  //
  // roof_insulation: {
  // 	title: `Dach- bzw. Dachbodendämmung`,
  // 	text: `Bitte die Stärke der Dämmung des Dachs bzw. Dachbodens in cm angeben. Sollte das Dach bzw. der Dachboden nicht gedämmt sein, geben Sie 0 ein.`,
  // },

  /**
   * Step 3
   */

  ba_windows_glas_type: {
    title: `Verglasungsart`, text: `Bitte wählen Sie die Verglasungsart der Fenster aus, die überwiegt.`
  },

  ba_roof_windows_frame: {
    title: `Fenster (Dachfenster)`, text: `Bitte wählen Sie die Art der Fenster aus, die überwiegt. `
  },

  sun_protection_18599: {
    title: `Sommerlicher Wärmeschutz`,
    text: `Um zu bestimmen, ob der sommerliche Wärmeschutz bei Gebäuden eingehalten wurde, muss ein Sonnenschutz an Ost-, Süd- und Westfenstern vorhanden sein. Dieser kann in Form von außenliegenden Jalousien, Rollläden, Markisen oder ähnlichem vorhanden sein. <br><br>Bitte geben Sie an, ob ein solcher Sonnenschutz vorhanden ist.`
  },

  owner_lives_in_property: {
    title: `Zusätzliche Fragen`,
    text: `War vor dem Einbau der aktuellen Heizung ebenfalls eine Einzelraum-Stromdirektheizung verbaut? Falls dies der Fall ist, könnte eine Sonderregelung für Sie zutreffen. <br>Dies gilt auch, wenn das Objekt über eine Einzelraum-Stromdirektheizung als Wärmeerzeuger verfügt und 1-2 Wohnungen umfasst, sowie der Eigentümer eine dieser Wohnungen selbst bewohnt. <br><br>Bei Fragen hierzu steht Ihnen unser Kundensupport gerne zur Verfügung.`
  },

  durchlauferhitzer_elektronisch_geregelt: {
    title: `Regelung des Durchlauferhitzers`,
    text: `Ein elektronisch geregelter Durchlauferhitzer verfügt zusätzlich zu einem Einlauftemperatursensor und einem Durchflusssensor auch über einen Auslauftemperatursensor.`
  },

  biomasse_checkbox_feste_biomasse: {
    title: `Biomassekessel-Kriterien:`, text: `Bitte bestätigen Sie, dass Ihr Biomassekessel die folgenden drei Kriterien erfüllt:<br><br>
<div class="content">
<ul>
<li>
<b>Automatische Beschickung und Wasser als Wärmeträger:</b> Der Ofen muss über ein automatisches Beschickungssystem verfügen, welches die Biomasse selbstständig zuführt. Zudem muss Wasser als Wärmeträger im Heizsystem verwendet werden.
</li>
<li>
<b>Exklusive Verwendung von Biomasse:</b> Es darf ausschließlich Biomasse als Brennmaterial verwendet werden. Andere Brennstoffe wie Kohle, Öl oder Gas sind nicht zulässig.
</li>
<li>
<b>Einhalten von EU-Vorgaben zur Nachhaltigkeit:</b> Die eingesetzte Biomasse muss den Vorgaben der Verordnung (EU) 2023/1115 des Europäischen Parlaments und des Rates vom 31. Mai 2023 entsprechen. Diese Verordnung bezieht sich auf die Bereitstellung bestimmter Rohstoffe und Erzeugnisse, die mit Entwaldung und Waldschädigung in Verbindung stehen. Die Biomasse muss also nachhaltig und ohne negative Auswirkungen auf Wälder produziert worden sein.
</li>
</ul>
</div>
<br>
Bitte überprüfen Sie sorgfältig, ob Ihr Biomassekessel diese Anforderungen erfüllt, bevor Sie fortfahren.
`
  },

  waermepumpen_hybrid_checkbox: {
    title: `Hybrid-Wärmepumpen-Kriterien:`, text: `
Bitte stellen Sie sicher, dass Ihr Heizsystem die folgenden Kriterien erfüllt:<br><br>
<div class="content">
<ul>
<li>
<b>Einsatz des Spitzenlasterzeugers:</b> Der Spitzenlasterzeuger wird nur dann eingesetzt, wenn der Wärmebedarf Ihres Gebäudes nicht mehr vollständig von der Wärmepumpe gedeckt werden kann.
</li>
<li>
<b>Gemeinsame, fernansprechbare Steuerung:</b>  Ihr System sollte eine integrierte Steuerungseinheit besitzen, die sowohl die Wärmepumpe als auch den Spitzenlasterzeuger regelt.
</li>
</ul>
</div>
<br>
Bitte überprüfen Sie sorgfältig, ob Ihr Kessel diese Anforderungen erfüllt, bevor Sie fortfahren.
`
  },

  ba_roof_dormers_count: {
    title: `Anzahl der Dachgauben`, text: `<img alt="Dachgauben" class="m-r-xs" src="/images/form/Dachgauben.png" style="width: auto;height:160px;" align=left>
Geben Sie die Anzahl der Dachgauben ein, die das Objekt besitzt. `
  },

  ba_roof_dormers_height: {
    title: `Höhe der Dachgauben`, text: `<img alt="Dachgauben" class="m-r-xs" src="/images/form/Dachgaube_hoehe.png" style="width: auto;height:160px;" align=left>
Geben Sie hier die durchschnittliche Höhe der Dachgauben ein.`
  },

  ba_roof_dormers_width: {
    title: `Breite der Dachgauben`, text: `Geben Sie die durchschnittliche Breite der Dachgauben ein.`
  },

  ba_roof_dormers_depth: {
    title: `Tiefe der Dachgauben`, text: `
		<img alt="Dachgauben" class="m-r-xs" src="/images/form/Dachgaube_tiefe.png" style="width: auto;height:160px;" align=left>
Die Tiefe der Dachgauben wird von der oberen Kante bis zur Dachfläche gemessen. Sollten die Dachgauben unterschiedlich tief sein, geben Sie bitte die durchschnittliche Tiefe an.`
  },

  ba_attic2_existing: {
    title: `2. Dachgeschoss`, text: `<img alt="Vollgeschosse" class="m-r-xs " src="/images/form/Dachgeschoss2.png" style="width: auto;height:160px;" align=left>
		Ein 2. Dachgeschoss ist ein zusätzliches Geschoss, das im Dachgeschoss eines Hauses untergebracht ist. Es ist eine Erweiterung des normalen Dachgeschosses, das üblicherweise als Wohnraum oder als Abstellfläche genutzt wird.`
  },

  ba_attic2_height: {
    title: `Höhe der 2. Dachgeschossebene`,
    text: `Bitte geben Sie die Höhe des Dachbodens über dem größeren Dachgeschoss an. Messen Sie dazu die Entfernung von der Oberkante des Bodens bis zum höchsten Punkt des Dachs, normalerweise die Firstpfette.`
  },

  ba_attic2_heated: {
    title: `2. Ebene beheizt`,
    text: `Geben Sie bitte an, ob Ihr Dachboden (kleineres Dachgeschoss) entweder direkt oder durch einen Luftverbund beheizt ist. Ist das Dachgeschoss nur teilweise beheizt, so geben Sie bitte beheizt an. In diesem Kontext bezieht sich das Wort <b>"Dachgeschoss" auf das höchste Stockwerk, das schräge Decken</b> besitzt. Andere Bezeichnungen wären Spitzboden oder Dachboden.`
  },

  property_picture: {
    title: `Gebäudebild`,
    text: `Sofern vorhanden können Sie ein Gebäudefoto (Außenansicht) hochladen. Dieses Bild erscheint auf dem Energieausweis.`
  },

  ba_windows_year: {
    title: `Baujahr der Fenster`,
    text: `Bei mehreren Fensterbaujahren geben Sie bitte jenes an, welches die meisten Fenster betrifft. Geben Sie kein Fensterbaujahr an, wird das Gebäudebaujahr angenommen.`
  },

  ba_windows_surface_area: {
    title: `Fensterfläche`, text: `Wählen Sie in diesem Feld die vorhandene Fensterfläche aus.`
  },

  ba_roof_windows_surface_area: {
    title: `Fläche der Dachfenster`, text: `Bitte geben Sie die Gesamtfläche der Fenster im Dachgeschoss an. `
  },


  external_wall_insulation: {
    title: `Gebäudesanierung vorhanden`, text: `
		Bitte prüfen Sie, ob das Gebäude den <b>Wärmeschutzstandard von 1977</b> erfüllt. Die Kriterien sind erfüllt, wenn Ihr Gebäude:
<br>
<b>1.</b> Überwiegend Außenwände hat, die entweder aus 24 cm dickem Bimsstein, Porenbeton, Blocksteinen bestehen, 38 cm Kalksandstein mit mindestens 6 cm Dämmung oder zweischaliges Mauerwerk mit 8 cm Dämmung aufweisen.
<br>
<b>2.</b> Fenster aus Holz oder Kunststoff mit Doppel- oder Isolierverglasung besitzt.
<br>
<b>3.</b> Ein gedämmtes Dach hat, wobei die Dämmung entweder 18 cm auf den Sparren, 15 cm zwischen den Sparren oder 8 cm auf dem Dachboden beträgt.
<br>
<b>4.</b> Bei einem unbeheizten Keller eine 5,5 cm dicke Dämmung der Kellerdecke vorhanden ist (bei beheizten Kellern oder ohne Keller ist keine Dämmung erforderlich).
<br>
<br>
<b>Orientierungshilfe anhand von U-Werten.</b><br>
Die folgenden Referenzwerte repräsentiert die Anforderungen, die für Gebäude in der Baualtersklasse 1979–1983 typisch waren und ist daher eine gute Orientierung für die WSchVO 1977.<br>
<b>Außenwände:</b> U-Wert von 0,9 W/(m²·K) oder kleiner<br>
<b>Dach:</b> U-Wert von 0,6 W/(m²·K) oder kleiner <br>
<b>oberste Geschossdecke:</b> U-Wert von 0,6 W/(m²·K) oder kleiner <br>
<br>
<br>
Wenn alle Bedingungen erfüllt sind, wählen Sie bitte die Checkbox an. Diese Angaben helfen uns, Sie korrekt für einen Verbrauchs- oder Bedarfsausweis zu kategorisieren.

`
  },

  water_heating: {
    title: `Warmwasser enthalten?`,
    text: `Bitte geben Sie hier an, ob der Warmwasser-Energieverbrauch bereits in dem oben angegebenen Verbrauch enthalten ist oder nicht. Sie können den Warmwasser-Energieverbrauch auch separat angeben.`
  },

  water_heating2: {
    title: `Warmwasser enthalten?`,
    text: `Sollte keine Warmwasserbereitung über die zweite Heizungsanlage erfolgen, so wählen Sie bitte "Keine Warmwasserbereitung über die zweite Heizungsanlage" aus.<br><br> Bitte geben Sie hier an, ob der Warmwasser-Energieverbrauch bereits in dem oben angegebenen Verbrauch enthalten ist oder nicht. Sie können den Warmwasser-Energieverbrauch auch separat angeben.`
  },

  water_heating2_BA: {
    title: "2. Warmwasserbereitung",
    text: "Bitte geben Sie die Art der zweiten, sprich der untergeordneten, Warmwasserbereitung an."
  },

  water_heating_percent: {
    title: `Wasserverbrauch in Prozent`,
    text: `Geben Sie hier den Anteil der Warmwasserversorgung an. Der Standardwert beträgt 18 %.`
  },

  water_heating2_percent: {
    title: `Wasserverbrauch in Prozent (Sekundär)`,
    text: `Geben Sie den prozentualen Anteil des Warmwassers an, der von der zweiten Heizungsanlage erhitzt wird.`
  },


  ba_pv_area: {
    title: `Kollektorfläche`, text: `Bitte geben Sie hier die Kollektorfläche an.`
  },


  /**
   * Step 4
   */

  ba_heater_type: {
    title: `Heizungsanlage`,
    text: `Falls es verschiedene Heizungsanlagen gibt, wählen Sie bitte die "Hauptanlage" aus.`
  },

  ba_heater_location: {
    title: `Position der Heizung`,
    text: `Diese Frage bezieht sich darauf, ob die Heizungsanlage, wie z. B. der Heizkessel oder die Wärmepumpe, innerhalb der beheizten Zonen des Gebäudes installiert ist. Der beheizte Bereich umfasst alle Räume, die aktiv beheizt werden, um eine angenehme Raumtemperatur zu gewährleisten. Ein Beispiel wäre, dass der Heizkessel sich im Keller befindet, der beheizt wird.`
  },
  ba_heater2_location: {
    title: `Position der 2. Heizung`,
    text: `Diese Frage bezieht sich darauf, ob die Heizungsanlage, wie z. B. der Heizkessel oder die Wärmepumpe, innerhalb der beheizten Zonen des Gebäudes installiert ist. Der beheizte Bereich umfasst alle Räume, die aktiv beheizt werden, um eine angenehme Raumtemperatur zu gewährleisten. Ein Beispiel wäre, dass der Heizkessel sich im Keller befindet, der beheizt wird.`
  },

  ba_heater2_type: {
    title: `Sekundäre Heizungsanlage`, text: `Wählen Sie hier Ihre zweite Heizungsanlage aus.`
  },

  ba_heater2_coverage_share: {
    title: `Deckungsanteil der zweiten Heizungsanlage`,
    text: `Bitte geben Sie an, welcher Anteil des Wärmebedarfs von der zweiten Heizungsanlage abgedeckt wird. Es ist wichtig, dass Sie diese Informationen angeben, um sicherzustellen, dass der Energieausweis korrekt und vollständig ist.`
  },

  ba_heater_night_shutdown: {
    title: `Nachtabschaltung`, text: `Bitte geben Sie die Einstellung der Heizungsanlage an.`
  },

  ba_heater_distribution: {
    title: `Verteilung Heizung`,
    text: `In der Regel erfolgt die Verteilung bei <b>Einfamilienhäusern</b> zentral bzw. bei Einzelfeuerstätten als dezentrales System.<br><b>Mehrfamilienhäuser</b> weisen meist eine wohnungsweise Verteilung der Heizung auf. <br>Bitte wählen Sie das auf Ihre Immobilie zutreffende System aus.`
  },

  ba_heater2_distribution: {
    title: `Verteilung 2. Heizung`,
    text: `In der Regel erfolgt die Verteilung bei <b>Einfamilienhäusern</b> zentral bzw. bei Einzelfeuerstätten als dezentrales System.<br><b>Mehrfamilienhäuser</b> weisen meist eine wohnungsweise Verteilung der Heizung auf. <br>Bitte wählen Sie das auf Ihre Immobilie zutreffende System aus.`
  },


  ba_blower_door_test: {
    title: `Wurde eine Dichtheitsprüfung durchgeführt?`,
    text: `Bitte geben Sie an, ob bei Ihrer Immobilie eine Dichtheitsprüfung (z. B. sogenannter "Blower-door-test") durchgeführt wurde. Wenn ja, bitte geben Sie an, welche der Kategorien bei Ihnen zutrifft.`
  },


  reason_of_creation: {
    title: `Anlass`,
    text: `Wenn Sie den Energieausweis für eine Finanzierung oder einen Kreditantrag benötigen, wählen Sie bitte den Ausstellungsgrund "Sonstiges". Energieausweise mit den Ausstellungsgründen "Neubau" oder "Modernisierung" können gemäß § 80 Satz 1 und 2 GEG nicht bestellt werden.`
  },

  email: {
    title: `E-Mail`,
    text: `Bitte geben Sie eine gültige E-Mail-Adresse an, unter der wir Sie bei Rückfragen bezüglich Ihrer Angaben kontaktieren können.<br>Über die angegebene E-Mail-Adresse erhalten sie zudem die Bestellbestätigung sowie die Rechnung.`
  },

  ba_construction_method: {
    title: `Bauweise`,
    text: `Bitte geben Sie die Bauweise, die auf Ihre Immobilie zutrifft, an. Wenn es verschiedene Bauweisen gibt, geben Sie bitte die überwiegende an. `
  },

  ba_construction_detail: {
    title: `Bauweise (Details)`, text: `Bitte geben Sie die Art der Bauweise im Detail an.<br><br>
Wenn Sie eine zusätzliche Dämmung besitzen, können Sie diese im nächsten Schritt angeben. Falls Sie Ihr Außenmaterial nicht aus der Liste auswählen können oder Sie den genauen U-Wert kennen, senden Sie uns gerne den U-Wert zu.`
  },

  ba_roof_construction: {
    title: `Dachkonstruktion`,
    text: `Bitte geben Sie an, ob Ihr Gebäude massiv (kein Holz) oder aus Holz gebaut ist. Flachdächer sind in der Regel massiv (nicht aus Holz) und Satteldächer meist als Holzbau errichtet.`
  },

  basement_heated: {
    title: `Was liegt unterhalb des Erdgeschosses?`,
    text: `Bitte geben Sie an, ob ein Keller vorhanden bzw. auch beheizt ist. Beheizt bedeutet hier, dass sich in einem überwiegenden Teil der Räume Heizkörper befinden. Dabei spielt es keine Rolle, ob Sie diese anschalten oder nicht. <br><br>Sollte nur der Heizungsraum indirekt beheizt werden, so zählt dies nicht als beheizter Keller.`
  },
  ba_heater_distribution_building_year: {
    title: `Baujahr des Rohrleitungssystems`,
    text: `Geben Sie hier das Baujahr der freiliegenden Heizungsrohre an. Sollten die Rohre nicht freiliegen, geben Sie das Baujahr des Heizungssystems an.`
  },

  ba_heater_ventilation_rate: {
    title: `Luftwechselrate`,
    text: `Geben Sie an, ob für das Haus eine Luftdichtheitsprüfung vorliegt oder nicht. Als undicht  versteht man z. B. Fenster ohne funktionstüchtige Lippendichtung oder beheizte Dachgeschosse mit Dachflächen ohne luftdichte Ebene.`
  },

  basement_percentage: {
    title: "Unterkellerung",
    text: "Geben Sie den Prozentwert der beheizbaren Kellerfläche in Bezug zur Grundfläche des Erdgeschosses an."
  },
  basement_ceiling: {
    title: `Kellerdeckenbauweise`, text: `Bitte geben Sie die Bauweise Ihrer Kellerdecke an.`
  },

  basement_bottom: {
    title: `Bodenplatte`, text: `Bitte geben Sie die Bauweise der Bodenplatte gegen Erdreich an.`
  },

  insulation_measure_walls: {
    title: `Dämmung (Außenwände)`,
    text: `Bitte geben Sie an, ob Ihre Außenwände gedämmt sind. Geben Sie die durchschnittliche Dicke der Dämmung OHNE die Konstruktionsschicht an. `
  },

  insulation_measure_ceiling: {
    title: `Dämmung (Dach oder oberste Geschossdecke)`,
    text: ` Bitte geben Sie hier an, ob und wie stark Ihr Dach bzw. die oberste Geschossdecke (Dachgeschoss) gedämmt sind. Wenn beide Gebäudeteile gedämmt sind, geben Sie die stärkere Dämmung an. Bitte geben Sie nur die Dämmung an. `
  },

  insulation_measure_basement: {
    title: `Dämmung (Fußboden / Keller)`,
    text: `Bitte geben Sie an, ob und wie stark Ihre Kellerdecke oder die Bodenplatte gedämmt ist. Wenn beide Gebäudeteile gedämmt sind, geben Sie bitte die stärkere Dämmung an. Beachten Sie, nur die Dämmung anzugeben. <br>Sollten Sie über eine Trittschalldämmung verfügen, teilen Sie uns diese bitte ebenfalls mit.`
  },

  insulation_measure_basement_walls: {
    title: `Dämmung (Kellerwände)`,
    text: `Bitte geben Sie hier an, ob und wie stark Ihre Kellerwände gedämmt sind. Bitte geben Sie Dämmung in Zentimeter an.`
  },

  insulation_measure_walls_area_percentage: {
    title: "Dämmung (Außenwände)",
    text: "Bitte geben Sie an, wie viel Prozent der Außenwandfläche gedämmt ist. Tragen Sie den Anteil als Prozentwert (0–100 %) ein."
  },
  insulation_measure_ceiling_area_percentage: {
    title: "Dämmung (Dach oder oberste Geschossdecke)",
    text: "Bitte geben Sie an, wie viel Prozent der Fläche von Dach oder oberster Geschossdecke gedämmt ist. Tragen Sie den Anteil als Prozentwert (0–100 %) ein."
  },
  insulation_measure_basement_area_percentage: {
    title: "Dämmung (Fußboden / Keller)",
    text: "Bitte geben Sie an, wie viel Prozent der Kellerdecke oder Bodenplatte gedämmt ist. Tragen Sie den Anteil als Prozentwert (0–100 %) ein."
  },
  insulation_measure_basement_walls_area_percentage: {
    title: "Dämmung (Kellerwände)",
    text: "Bitte geben Sie an, wie viel Prozent der Kellerwandfläche gedämmt ist. Tragen Sie den Anteil als Prozentwert (0–100 %) ein."
  },

  file_upload_210: {
    title: `Foto des Gebäudes`,
    text: `Bitte laden Sie hier Fotos von Ihrem Gebäude hoch. Idealerweise ist auf dem Foto das gesamte Gebäude zu sehen.`
  },

  file_upload_212: {
    title: `Foto des Typenschilds der Heizungsanlage`,
    text: `Bitte laden Sie hier Fotos von Ihrem Wärmeerzeuger hoch. <br>Sie können mehrere Fotos hochladen. <br><br>Die Fotos sollten Ihre Angaben nachvollziehbar bestätigen. Hilfreich sind Fotos von Ihrer Heizungsanlage und Warmwasserbereitung (Typenschilder der Heizung UND Warmwasserbereitung), aber auch zusätzlich die Fotos der Gerätschaften wie Heizungskessel, Heizkreispumpe, Warmwasser-Speicherung usw.. <br><br>Möglich sind auch Rechnungen oder Schornsteinfegerprotokolle, welche Ihre Heizungs-/Warmwasseranlage belegen.`
  },

  file_upload_213: {
    title: `Detailfoto Dach`,
    text: `Bitte laden Sie ein Foto von Ihrem Dach(-stuhl) hoch. Wenn die Konstruktion nicht sichtbar ist bzw. Ihr Dachgeschoss nicht zugänglich ist, ist eine Außenansicht von der Seite möglich.`
  },

  file_upload_214: {
    title: `Detailfoto Fenster`,
    text: `Bitte laden Sie ein Foto von einem Fenster hoch, das der Art entspricht, die in Ihrer Immobilie am meisten vertreten ist.`
  },

  file_upload_215: {
    title: `Außenwand`,
    text: `Bitte laden Sie hier ein Foto der Außenwand hoch, das die Konstruktion und die Dicke der Wärmedämmung zeigt. Möglich sind z. B. Fotos einer vergangenen Umbaumaßnahme. Besitzen Sie solche nicht, sind Außen-/Innenfotos möglich. `
  },

  payment_bank_holder: {
    title: `Kontoinhaber`,
    text: `Geben Sie hier den Namen des Kontoinhabers an, von dem wir das Geld einmalig einziehen können. `
  },

  payment_bank_iban: {
    title: `IBAN`,
    text: `Geben Sie hier die IBAN des Kontos ein, von dem wir den Betrag einmalig nach der Auftragsstellung einziehen sollen. Wir werden den Betrag 2-5 Tage nach Ihrer Bestellung von Ihrem Konto einziehen.`
  }


};
export default HELPTEXT;
